import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import ContentContainer from "~/components/layout/ContentContainer";
import SectionWrapper from "~/components/layout/SectionWrapper";

import UnderlineTitle from "~/components/typography/UnderlineTitle";

import { h1 } from "~/styles/typographyStyles";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

const Title = styled.h1`
    ${h1};
    padding-top: 40px;
`;

const Wrapper = styled(SectionWrapper)`
    padding-bottom: 60px;
`;

const NewsPageHeader = ({ title, category = "", breadcrumbsAtTop = false }) => {
    return (
        <Wrapper
            element="div"
            backgroundColor="gray"
            withSmallerPadding={!breadcrumbsAtTop}
            noMarginBottom={!breadcrumbsAtTop}
        >
            <ContentContainer>
                {category ? (
                    <UnderlineTitle paddingTop="25px" noMarginBottom={true}>
                        {category}
                    </UnderlineTitle>
                ) : null}

                <Title>{sanitizeAndParseHTML(title)}</Title>
            </ContentContainer>
        </Wrapper>
    );
};

NewsPageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    category: PropTypes.string,
    breadcrumbsAtTop: PropTypes.bool,
};

export default NewsPageHeader;
